<template>
  <div class="auth-status">
    <h3>Authentication Status</h3>
    <div class="status-info">
      <div class="status-item">
        <span class="status-label">Status:</span>
        <span class="status-value" :class="{ 'authenticated': isAuthenticated, 'not-authenticated': !isAuthenticated }">
          {{ isAuthenticated ? 'Authenticated' : 'Not Authenticated' }}
        </span>
      </div>
      
      <div v-if="isAuthenticated" class="status-item">
        <span class="status-label">Token:</span>
        <div class="token-display">
          <span class="token-value">{{ displayToken }}</span>
          <button class="toggle-btn" @click="toggleShowFullToken">
            {{ showFullToken ? 'Hide' : 'Show Full' }}
          </button>
        </div>
      </div>
      
      <div class="actions">
        <button class="action-btn" @click="$router.push('/auth')">
          {{ isAuthenticated ? 'Change Token' : 'Set Token' }}
        </button>
        <button v-if="isAuthenticated" class="action-btn logout" @click="logout">
          Logout
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AuthStatus',
  data() {
    return {
      showFullToken: false
    }
  },
  computed: {
    ...mapGetters('auth', ['token', 'isAuthenticated']),
    displayToken() {
      if (!this.token) return 'No token'
      
      if (this.showFullToken) {
        return this.token
      } else {
        // Show first 10 characters and last 4 characters
        return this.token.substring(0, 10) + '...' + this.token.substring(this.token.length - 4)
      }
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    toggleShowFullToken() {
      this.showFullToken = !this.showFullToken
    }
  }
}
</script>

<style scoped>
.auth-status {
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}

h3 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 18px;
}

.status-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.status-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.status-label {
  font-weight: 500;
  color: var(--tg-theme-hint-color);
}

.status-value {
  font-family: monospace;
  padding: 5px 10px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.05);
}

.authenticated {
  color: #4caf50;
}

.not-authenticated {
  color: #f44336;
}

.token-display {
  display: flex;
  align-items: center;
  gap: 10px;
}

.token-value {
  flex: 1;
  font-family: monospace;
  padding: 8px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.05);
  word-break: break-all;
}

.toggle-btn {
  padding: 5px 10px;
  border-radius: 4px;
  background-color: transparent;
  border: 1px solid var(--tg-theme-button-color);
  color: var(--tg-theme-button-color);
  cursor: pointer;
  font-size: 12px;
}

.actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.action-btn {
  flex: 1;
  padding: 8px 12px;
  border-radius: 6px;
  background-color: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.logout {
  background-color: #f44336;
}
</style> 